import React, { useState, useEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import { Card, Button, Popover, Modal } from 'antd';

const TournamentBracket = () => {
  // 状态管理
  const [players, setPlayers] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [eliminated, setEliminated] = useState([]);
  const [champion, setChampion] = useState(null);
  const [connections, setConnections] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const bracketRef = useRef(null);
  
  // 图片基础URL
  const BASE_URL = "http://9ha.top:3000";
  
  // 初始化选手数据
  useEffect(() => {
    // 从API获取初始数据
    const fetchData = async () => {
      try {
        const initialPlayers = [
            {
                "tag": "团员",
                "name": "抽象",
                "text": "排行榜第14名",
                "img": "/images/抽象.jpg",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
              },
              {
                "tag": "团员",
                "name": "SD译文",
                "text": "排行榜第7名",
                "img": "/images/译文.jpg",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
              },
            {
                "tag": "团员",
                "name": "SD敢对刀",
                "text": "排行榜第1名",
                "img": "/images/SD敢对刀.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD皇",
                "text": "排行榜第3名",
                "img": "/images/皇.jpg",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
              },
            {
                "tag": "团员",
                "name": "SD太空肠",
                "text": "排行榜第1名",
                "img": "/images/SD太空肠.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD神输降临",
                "text": "排行榜第1名",
                "img": "/images/SD神输降临.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "尾刀",
                "text": "排行榜第1名",
                "img": "/images/尾刀.jpg",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
              },
            {
                "tag":"团员",
                "name":"SD失尽",
                "text":"排行榜第1名",
                "img":"/images/SD失尽.png",
                "show":true,
                "tk":"https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD-小碎",
                "text": "排行榜第1名",
                "img": "/images/SD-小碎.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD拾衣",
                "text": "排行榜第1名",
                "img": "/images/SD拾衣.jpg",
                "show": true,
                "tk": "#"
            },
            {
                "tag": "团员",
                "name": "SD卫星",
                "text": "排行榜第6名",
                "img": "/images/卫星.jpg",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
              },
            {
                "tag": "团员",
                "name": "SD敦吕",
                "text": "排行榜第1名",
                "img": "/images/SD敦吕.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD阿文老八",
                "text": "排行榜第1名",
                "img": "/images/SD阿文老八.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD面圻",
                "text": "排行榜第1名",
                "img": "/images/SD面圻.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团员",
                "name": "SD风",
                "text": "排行榜第1名",
                "img": "/images/SD风.png",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            },
            {
                "tag": "团长",
                "name": "灰Damn",
                "text": "666团长亲自下台",
                "img": "/images/灰Damn.jpg",
                "show": true,
                "tk": "https://www.douyin.com/user/MS4wLjABAAAAKIWyU7vvvvRcyDpg9CpLBzqzTVzoANqgz9NgOllEtkJqsBp7vU6GvSMRFOICO0Jb"
            }
        ]
        
        // 处理图片路径 - 添加基础URL
        const processedPlayers = initialPlayers.map(player => ({
          ...player
        }));
        
        // 从localStorage中读取保存的数据
        const savedData = localStorage.getItem('tournamentData');
        
        if (savedData) {
          const parsedData = JSON.parse(savedData);
          setPlayers(parsedData.players || processedPlayers);
          setRounds(parsedData.rounds || []);
          setEliminated(parsedData.eliminated || []);
          setChampion(parsedData.champion || null);
          setConnections(parsedData.connections || []);
          
          // 如果没有轮次数据，初始化比赛
          if (!parsedData.rounds || parsedData.rounds.length === 0) {
            initializeTournament(processedPlayers);
          }
        } else {
          // 首次加载时初始化数据
          setPlayers(processedPlayers);
          initializeTournament(processedPlayers);
        }
      } catch (error) {
        console.error('Failed to fetch player data:', error);
        // 使用空数据初始化以防错误
        setPlayers([]);
        initializeTournament([]);
      }
    };
    
    fetchData();
  }, []);

  // 保存数据到本地存储
  useEffect(() => {
    if (players.length > 0) {
      const tournamentData = {
        players,
        rounds,
        eliminated,
        champion,
        connections
      };
      localStorage.setItem('tournamentData', JSON.stringify(tournamentData));
    }
  }, [players, rounds, eliminated, champion, connections]);

  // 初始化比赛
  const initializeTournament = (players) => {
    const activePlayers = players.filter(player => player.show);
    
    // 创建第一轮比赛
    const firstRound = createRound(activePlayers);
    setRounds([firstRound]);
    setEliminated([]);
    setChampion(null);
    setConnections([]);
    setModalVisible(false);
  };

  // 创建新的一轮比赛
  const createRound = (players) => {
    const matches = [];
    for (let i = 0; i < players.length; i += 2) {
      matches.push({
        id: `match-${Date.now()}-${i}`,
        player1: players[i],
        player2: players[i + 1] || null,
        winner: null,
        timestamp: null
      });
    }
    return matches;
  };

  // 处理选手晋级
  const handleAdvance = (player, matchId, roundIndex) => {
    const updatedRounds = [...rounds];
    const currentRound = updatedRounds[roundIndex];
    const matchIndex = currentRound.findIndex(m => m.id === matchId);
    
    if (matchIndex === -1) return;
    
    const match = currentRound[matchIndex];
    
    // 设置获胜者和时间戳
    match.winner = player;
    match.timestamp = Date.now();
    
    // 确定失败者
    const loser = match.player1?.name === player.name ? match.player2 : match.player1;
    
    if (loser) {
      // 更新淘汰列表
      setEliminated(prev => [...prev, { ...loser, eliminatedAt: Date.now() }]);
    }
    
    // 更新轮次
    updatedRounds[roundIndex] = [...currentRound];
    setRounds(updatedRounds);
    
    // 检查当前轮次是否全部完成
    const isRoundComplete = currentRound.every(match => match.winner);
    if (isRoundComplete) {
      advanceToNextRound(roundIndex, currentRound);
    }
  };

  // 晋级到下一轮
  const advanceToNextRound = (currentRoundIndex, currentMatches) => {
    const winners = currentMatches.map(match => match.winner);
    
    // 如果只剩一个选手，成为冠军
    if (winners.length === 1) {
      setChampion(winners[0]);
      updateRankings(winners[0]);
      setModalVisible(true); // 显示结果模态框
      return;
    }
    
    // 创建下一轮比赛
    const nextRound = createRound(winners);
    const updatedRounds = [...rounds];
    
    // 如果下一轮不存在，添加新轮次
    if (currentRoundIndex + 1 >= updatedRounds.length) {
      updatedRounds.push(nextRound);
    } else {
      // 更新现有轮次
      updatedRounds[currentRoundIndex + 1] = nextRound;
    }
    
    setRounds(updatedRounds);
    
    // 更新连线
    updateConnections(currentMatches, nextRound);
  };

  // 更新晋级连线
  const updateConnections = (prevRound, nextRound) => {
    const newConnections = [];
    
    prevRound.forEach((match, index) => {
      if (match.winner) {
        const nextMatchIndex = Math.floor(index / 2);
        if (nextRound[nextMatchIndex]) {
          newConnections.push({
            from: `match-${match.id}-winner`,
            to: `match-${nextRound[nextMatchIndex].id}`
          });
        }
      }
    });
    
    setConnections(prev => [...prev, ...newConnections]);
  };

  // 更新排行榜
  const updateRankings = (championPlayer) => {
    // 按淘汰时间排序（最后淘汰的排名更高）
    const sortedEliminated = [...eliminated].sort((a, b) => 
      a.eliminatedAt - b.eliminatedAt
    );
    
    // 更新选手排名
    const updatedPlayers = players.map(player => {
      // 冠军
      if (player.name === championPlayer.name) {
        return { ...player, text: "排行榜第1名" };
      }
      
      // 其他选手
      const rankIndex = sortedEliminated.findIndex(p => p.name === player.name);
      if (rankIndex !== -1) {
        const rank = 16 - rankIndex;
        return { ...player, text: `排行榜第${rank}名` };
      }
      
      return player;
    });
    
    setPlayers(updatedPlayers);
  };

  // 导出为JSON
  const exportAsJSON = () => {
    // 准备排好序的选手数据
    const sortedPlayers = [...players]
      .filter(p => p.show)
      .sort((a, b) => {
        const aRank = parseInt(a.text?.match(/\d+/)?.[0] || 17);
        const bRank = parseInt(b.text?.match(/\d+/)?.[0] || 17);
        return aRank - bRank;
      })
      .map((player, index) => ({
        ...player,
        // 确保所有选手都有排名
        text: `排行榜第${index + 1}名`
      }));
    
    const tournamentData = sortedPlayers;
    
    const dataStr = JSON.stringify(tournamentData, null, 2);
    const dataUri = `data:application/json;charset=utf-8,${encodeURIComponent(dataStr)}`;
    
    const link = document.createElement('a');
    link.download = '赛程数据.json';
    link.href = dataUri;
    link.click();
  };

  // 重新开始比赛
  const restartTournament = () => {
    initializeTournament(players);
  };

  // 渲染选手卡片
  const renderPlayerCard = (player, matchId, roundIndex, position) => {
    if (!player || !player.show) {
      return (
        <div className="empty-slot" id={`match-${matchId}-${position}`}>
          <div className="empty-text">待晋级</div>
        </div>
      );
    }
    
    return (
      <Popover
        content={
          <div style={{ textAlign: 'center' }}>
            <Button 
              type="primary" 
              onClick={() => handleAdvance(player, matchId, roundIndex)}
              block
              disabled={!!champion}
            >
              晋级
            </Button>
          </div>
        }
        trigger="click"
      >
        <Card 
          className="player-card" 
          id={`match-${matchId}-${position === 1 ? 'player1' : 'player2'}`}
        >
          <div className="player-content">
            <img 
              src={'http://9ha.top:3000'+player.img} 
              alt={player.name} 
              className="player-avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${BASE_URL}/images/default.jpg`;
              }}
            />
            <div className="player-info">
              <div className="player-name">{player.name}</div>
              <div className="player-tag">{player.tag}</div>
            </div>
          </div>
        </Card>
      </Popover>
    );
  };

  // 渲染比赛
  const renderMatch = (match, index, roundIndex) => {
    return (
      <div 
        className="match-container" 
        key={match.id}
        id={match.id}
      >
        <div className="match-content">
          {renderPlayerCard(match.player1, match.id, roundIndex, 1)}
          <div className="vs-container">
            <div className="vs">VS</div>
          </div>
          {renderPlayerCard(match.player2, match.id, roundIndex, 2)}
          
          {match.winner && (
            <div className="winner-indicator" id={`match-${match.id}-winner`}>
              <div className="arrow">→</div>
              <div className="winner-badge">
                <div className="winner-name">{match.winner.name}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // 渲染轮次
  const renderRound = (round, roundIndex) => {
    const roundNames = ["16进8", "8进4", "半决赛", "决赛"];
    
    return (
      <div className="tournament-round" key={`round-${roundIndex}`}>
        <div className="round-header">
          <div className="round-title">
            {roundNames[roundIndex] || `第${roundIndex + 1}轮`}
          </div>
          <div className="round-count">{round.length}组比赛</div>
        </div>
        
        <div className="matches-container">
          {round.map((match, matchIndex) => 
            renderMatch(match, matchIndex, roundIndex)
          )}
        </div>
      </div>
    );
  };

  // 渲染冠军
  const renderChampion = () => {
    if (!champion) return null;
    
    return (
      <div className="champion-container">
        <div className="champion-header">
          <div className="round-title">冠军</div>
          <div className="crown-icon">🏆</div>
        </div>
        <Card className="champion-card">
          <img 
            src={'http://9ha.top:3000'+champion.img} 
            alt={champion.name} 
            className="champion-avatar" 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = `${BASE_URL}/images/default.jpg`;
            }}
          />
          <div className="champion-name">{champion.name}</div>
          <div className="champion-tag">{champion.tag}</div>
          <div className="champion-text">{champion.text || "排行榜第1名"}</div>
        </Card>
      </div>
    );
  };

  // 渲染连线
  const renderConnections = () => {
    return (
      <svg className="connections-layer" width="100%" height="100%">
        {connections.map((conn, index) => {
          const fromEl = document.getElementById(conn.from);
          const toEl = document.getElementById(conn.to);
          
          if (!fromEl || !toEl) return null;
          
          const fromRect = fromEl.getBoundingClientRect();
          const toRect = toEl.getBoundingClientRect();
          const bracketRect = bracketRef.current.getBoundingClientRect();
          
          const startX = fromRect.right - bracketRect.left + 20;
          const startY = fromRect.top + fromRect.height / 2 - bracketRect.top;
          const endX = toRect.left - bracketRect.left - 20;
          const endY = toRect.top + toRect.height / 2 - bracketRect.top;
          
          // 创建曲线路径
          const controlX1 = startX + (endX - startX) * 0.3;
          const controlY1 = startY;
          const controlX2 = startX + (endX - startX) * 0.7;
          const controlY2 = endY;
          
          return (
            <path
              key={`conn-${index}`}
              d={`M${startX},${startY} C${controlX1},${controlY1} ${controlX2},${controlY2} ${endX},${endY}`}
              stroke="#1890ff"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              markerEnd="url(#arrowhead)"
            />
          );
        })}
        <defs>
          <marker id="arrowhead" markerWidth="10" markerHeight="7" 
            refX="10" refY="3.5" orient="auto">
            <polygon points="0 0, 10 3.5, 0 7" fill="#1890ff" />
          </marker>
        </defs>
      </svg>
    );
  };
  const handleExportAsJPG = () => {
    if (bracketRef.current) {
      html2canvas(bracketRef.current, {
        scale: 2, // 提高输出质量
        useCORS: true, // 允许跨域图片
        backgroundColor: "#ffffff" // 设置背景为白色
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/jpeg', 0.9);
        const link = document.createElement('a');
        link.download = '淘汰赛对阵图.jpg';
        link.href = imgData;
        link.click();
      });
    }
  };
  // 渲染结果模态框
  const renderResultModal = () => {
    if (!champion) return null;
    
    // 准备排好序的选手数据
    const sortedPlayers = [...players]
      .filter(player => player.show)
      .sort((a, b) => {
        const aRank = parseInt(a.text?.match(/\d+/)?.[0] || 17);
        const bRank = parseInt(b.text?.match(/\d+/)?.[0] || 17);
        return aRank - bRank;
      });
    
    return (
      <Modal
        title="比赛结果"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={800}
        centered
        style={{ top: 20 }}
      >
        <div className="result-container">
          <div className="champion-section">
            <div className="crown">👑</div>
            <img 
              src={'http://9ha.top:3000'+champion.img} 
              alt={champion.name} 
              className="champion-avatar-modal"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${BASE_URL}/images/default.jpg`;
              }}
            />
            <div className="champion-info">
              <div className="champion-name-modal">{champion.name}</div>
              <div className="champion-title">冠军</div>
              <div className="champion-tag-modal">{champion.tag}</div>
            </div>
          </div>
          
          <div className="rankings-section">
            <h3>最终排名</h3>
            <div className="rankings-grid">
              {sortedPlayers.map((player, index) => (
                <div className="ranking-card" key={player.name}>
                  <div className="rank-badge">{index + 1}</div>
                  <img 
                    src={'http://9ha.top:3000'+player.img} 
                    alt={player.name} 
                    className="ranking-avatar"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `${BASE_URL}/images/default.jpg`;
                    }}
                  />
                  <div className="ranking-info">
                    <div className="ranking-name">{player.name}</div>
                    <div className="ranking-tag">{player.tag}</div>
                    <div className="ranking-text">{player.text || `排行榜第${index + 1}名`}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div className="tournament-container">
      <div className="header">
        <h1>16强擂台赛</h1>
        <div className="controls">
        <Button 
            type="primary" 
            onClick={handleExportAsJPG} 
            style={{ marginRight: 10 }}
            >
            导出为JPG
            </Button>
          <Button 
            type="primary" 
            onClick={exportAsJSON} 
            style={{ marginRight: 10 }}
          >
            导出为JSON
          </Button>
          <Button onClick={restartTournament}>
            重新开始
          </Button>
        </div>
      </div>
      
      <div className="bracket-container" ref={bracketRef}>
        {renderConnections()}
        <div className="horizontal-bracket">
          {rounds.map((round, index) => renderRound(round, index))}
          {renderChampion()}
        </div>
      </div>
      
      {renderResultModal()}
    </div>
  );
};

// 添加CSS样式
const styles = `
.tournament-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 15px 25px;
  background: linear-gradient(135deg, #1a2a6c, #2a4cb5);
  border-radius: 12px;
  color: white;
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
}

.header h1 {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.controls {
  display: flex;
  gap: 12px;
}

.ant-btn {
  border-radius: 8px;
  font-weight: 500;
  height: 40px;
  padding: 0 20px;
}

.bracket-container {
  position: relative;
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  overflow: auto;
}

.connections-layer {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
  height: 100%;
}

.horizontal-bracket {
  display: flex;
  position: relative;
  z-index: 2;
  padding: 15px 0;
  gap: 40px;
}

.tournament-round {
  min-width: 260px;
  padding: 15px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid #e8f1fd;
}

.round-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #1890ff;
}

.round-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d39c4;
}

.round-count {
  background: #1890ff;
  color: white;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.matches-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.match-container {
  position: relative;
}

.match-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 15px;
  background: #f8fbff;
  border-radius: 10px;
  min-height: 180px;
  border: 1px solid #d6e8ff;
}

.player-card {
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8f1fd;
  background: white;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.player-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  border-color: #1890ff;
}

.player-content {
  display: flex;
  align-items: center;
  padding: 12px;
}

.player-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #1890ff;
  margin-right: 15px;
}

.player-info {
  flex: 1;
}

.player-name {
  font-weight: 600;
  font-size: 16px;
  color: #262626;
  margin-bottom: 4px;
}

.player-tag {
  color: #6c757d;
  font-size: 13px;
  background: #f0f7ff;
  padding: 3px 8px;
  border-radius: 20px;
  display: inline-block;
}

.vs-container {
  text-align: center;
  padding: 5px;
}

.vs {
  display: inline-block;
  font-weight: 600;
  color: #495057;
  background: #e9f2ff;
  border-radius: 20px;
  padding: 2px 14px;
  font-size: 14px;
}

.winner-indicator {
  position: absolute;
  right: -70px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

.arrow {
  font-size: 24px;
  color: #1890ff;
  margin-right: 5px;
  font-weight: bold;
}

.winner-badge {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 100px;
}

.winner-name {
  font-weight: 600;
  font-size: 14px;
  color: #1890ff;
}

.empty-slot {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
}

.empty-text {
  color: #adb5bd;
  font-style: italic;
  font-size: 14px;
}

.champion-container {
  min-width: 260px;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid #ffecb3;
}

.champion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ffc53d;
}

.crown-icon {
  font-size: 28px;
}

.champion-card {
  text-align: center;
  padding: 20px;
  border: 2px solid #ffc53d;
  background: linear-gradient(to bottom, #fffbe6, #fff3cc);
  border-radius: 10px;
}

.champion-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #ffc53d;
  margin: 0 auto 15px;
}

.champion-name {
  font-weight: 700;
  font-size: 20px;
  color: #262626;
  margin-bottom: 5px;
}

.champion-tag {
  color: #6c757d;
  font-size: 15px;
  margin-bottom: 10px;
}

.champion-text {
  font-weight: 700;
  color: #1890ff;
  font-size: 16px;
  background: #e6f7ff;
  padding: 5px 12px;
  border-radius: 20px;
  display: inline-block;
}

/* 结果模态框样式 */
.result-container {
  padding: 10px;
}

.champion-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 15px;
  background: linear-gradient(135deg, #fffbe6, #fff3cc);
  border-radius: 14px;
  margin-bottom: 25px;
  position: relative;
  overflow: hidden;
  border: 2px solid #ffc53d;
}

.crown {
  font-size: 50px;
  position: absolute;
  top: -15px;
  left: 15px;
  transform: rotate(-25deg);
  opacity: 0.8;
}

.champion-avatar-modal {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #ffc53d;
  margin-bottom: 15px;
  z-index: 2;
}

.champion-info {
  text-align: center;
  z-index: 2;
}

.champion-name-modal {
  font-weight: 700;
  font-size: 24px;
  color: #262626;
  margin-bottom: 8px;
}

.champion-title {
  font-size: 20px;
  font-weight: 700;
  color: #d48806;
  margin-bottom: 6px;
}

.champion-tag-modal {
  font-size: 16px;
  color: #6c757d;
  background: rgba(255, 255, 255, 0.7);
  padding: 3px 12px;
  border-radius: 20px;
  display: inline-block;
}

.rankings-section h3 {
  text-align: center;
  font-size: 20px;
  color: #1d39c4;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1890ff;
}

.rankings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 15px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.ranking-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background: #f8fbff;
  border-radius: 10px;
  border: 1px solid #e8f1fd;
  transition: all 0.3s;
}

.ranking-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #1890ff;
}

.rank-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #1890ff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-bottom: 10px;
}

.ranking-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #1890ff;
  margin-bottom: 8px;
}

.ranking-info {
  text-align: center;
  width: 100%;
}

.ranking-name {
  font-weight: 600;
  font-size: 15px;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 3px;
}

.ranking-tag {
  font-size: 12px;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
}

.ranking-text {
  font-size: 12px;
  font-weight: 600;
  color: #1890ff;
}

@media (max-width: 1200px) {
  .horizontal-bracket {
    gap: 30px;
  }
  
  .tournament-round {
    min-width: 240px;
  }
}

@media (max-width: 992px) {
  .horizontal-bracket {
    flex-direction: column;
    gap: 30px;
  }
  
  .tournament-round {
    width: 100%;
  }
  
  .winner-indicator {
    position: static;
    transform: none;
    margin-top: 12px;
    justify-content: center;
  }
  
  .header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .bracket-container {
    padding: 10px;
  }
  
  .rankings-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
  
  .champion-section {
    padding: 20px 10px;
  }
  
  .champion-avatar-modal {
    width: 80px;
    height: 80px;
  }
  
  .champion-name-modal {
    font-size: 20px;
  }
}
`;

// 将样式添加到页面
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default TournamentBracket;